import * as tslib_1 from "tslib";
import { lazyEditGroup } from 'owa-group-edit-integration';
import { lazyOpenGroupSettings } from 'owa-group-settings-integration';
import { selectGroup } from 'owa-mail-folder-forest-actions';
import { lazyGroupHeaderCommandBarAction, lazyGroupHeaderNavigationButton, } from 'owa-group-header-actions';
import { lazyInitializeDeeplink, lazyDeeplinkActionType, lazyDeeplinkOnGroupDetailsLoadError, lazyDeeplinkOnGroupDetailsLoaded, } from 'owa-group-deeplinkaction-integration';
import { ensureValidGroupSmtpAddress, } from '../utils/mailGroupRouteSettings';
export default function mailGroupRouteHandler(parameters) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var groupSmtp, onGroupLoadSuccess, onGroupLoadError, onGroupLoadPromise, commandBarAction, groupHeaderNavigationButton, DeeplinkActionType, action, openGroupSettings, editGroup;
        var _this = this;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    groupSmtp = ensureValidGroupSmtpAddress(parameters);
                    if (!groupSmtp) {
                        return [2 /*return*/];
                    }
                    groupSmtp = groupSmtp.toLowerCase();
                    onGroupLoadSuccess = null;
                    onGroupLoadError = null;
                    if (!parameters.actionId) return [3 /*break*/, 2];
                    // import here since we expect to use this
                    return [4 /*yield*/, lazyDeeplinkOnGroupDetailsLoaded.import()];
                case 1:
                    // import here since we expect to use this
                    _a.sent();
                    onGroupLoadPromise = new Promise(function (resolve, reject) {
                        onGroupLoadSuccess = function () {
                            lazyDeeplinkOnGroupDetailsLoaded.importAndExecute();
                            resolve();
                        };
                        onGroupLoadError = function () {
                            lazyDeeplinkOnGroupDetailsLoadError.importAndExecute();
                            resolve();
                        };
                    });
                    _a.label = 2;
                case 2: return [4 /*yield*/, selectGroup(groupSmtp, 'groups', onGroupLoadSuccess, onGroupLoadError)];
                case 3:
                    _a.sent();
                    return [4 /*yield*/, lazyGroupHeaderCommandBarAction.import()];
                case 4:
                    commandBarAction = _a.sent();
                    return [4 /*yield*/, lazyGroupHeaderNavigationButton.import()];
                case 5:
                    groupHeaderNavigationButton = _a.sent();
                    commandBarAction(groupHeaderNavigationButton.Email);
                    if (!parameters.actionId) return [3 /*break*/, 7];
                    return [4 /*yield*/, lazyDeeplinkActionType.import()];
                case 6:
                    DeeplinkActionType = _a.sent();
                    action = DeeplinkActionType[parameters.actionId.toLowerCase()];
                    if (action != null) {
                        openGroupSettings = function (groupSmtp) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var openGroupSettings;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, lazyOpenGroupSettings.import()];
                                    case 1:
                                        openGroupSettings = _a.sent();
                                        openGroupSettings(groupSmtp);
                                        return [2 /*return*/];
                                }
                            });
                        }); };
                        editGroup = function (groupSmtp) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var editGroup;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, lazyEditGroup.import()];
                                    case 1:
                                        editGroup = _a.sent();
                                        editGroup(groupSmtp);
                                        return [2 /*return*/];
                                }
                            });
                        }); };
                        lazyInitializeDeeplink.importAndExecute(groupSmtp, action, openGroupSettings, editGroup);
                    }
                    _a.label = 7;
                case 7:
                    if (!onGroupLoadPromise) return [3 /*break*/, 9];
                    return [4 /*yield*/, onGroupLoadPromise];
                case 8:
                    _a.sent();
                    _a.label = 9;
                case 9: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=mailGroupRouteHandler.js.map